import React, { useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router'
import { withCapture, _ } from 'utils'
import { Formik } from 'formik'
import { showNotification } from 'features/notifications'
import { useDispatch } from 'react-redux'
import { showErrorNotification } from 'features/notifications/notificationsSlice'
import FullPageLoading from 'components/FullPageLoading'
import FormTabs from 'features/forms/FormTabs'
import SocialMedia from 'features/speakers/tabs/SocialMedia'
import { UpdateInvite, GetInviteByIdQuery, GetInviteByIdQueryVariables } from 'generated/graphql'
import { useEventSlug, useQuery } from 'hooks'
import { getNodes } from 'graphql/utils'
import { updateInvite } from '../graphql/mutation'
import About from '../tabs/About'
import { attendeeValidation } from './CreateAttendee'
import { inviteByIdQuery } from '../graphql/query'

const transformDataForForm = (data) => ({
    ...data,
    tags: (data?.tags || []).map((e) => e.id)
})

const UpdateAttendee = () => {
    const eventSlug = useEventSlug()
    const dispatch = useDispatch()
    const { id } = useParams<{ id: string }>()
    const [initialValues, setInitialValues] = useState<UpdateInvite>({})
    const [isUploading, setIsUploading] = useState(false)

    const { data, requestStatus } = useQuery<
        GetInviteByIdQuery, GetInviteByIdQueryVariables
    >(inviteByIdQuery, { eventSlug, filters: { id: +id } })
    const attendee = useMemo(() => (
        transformDataForForm(getNodes(data?.event?.invites)[0])
    ), [data])

    useEffect(() => {
        attendee && setInitialValues(attendee)
    }, [attendee])

    const handleSubmit = withCapture(async (values, { resetForm }) => {
        delete values.id
        delete values.status
        setIsUploading(true)
        const response = await updateInvite(attendee.id, values)
        setIsUploading(false)
        if (!response.data || response.errors.length) {
            dispatch(showErrorNotification(response.errors))
            return
        }

        resetForm({ values })
        setInitialValues(values)
        dispatch(showNotification({
            type: 'success',
            body: _('form.notification.update_success'),
        }))
    })

    if (requestStatus === 'loading') {
        return <FullPageLoading />
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={attendeeValidation}
            onSubmit={handleSubmit}
            enableReinitialize
        >
            <>
                <FormTabs
                    tabs={[
                        { id: 'about', name: _('attendee.tabs.about'), Component: About },
                        { id: 'social_media', name: _('attendee.tabs.social_media'), Component: SocialMedia },
                    ]}
                />
                {isUploading && <FullPageLoading isAbsolute />}
            </>
        </Formik>
    )
}

export default UpdateAttendee
